import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'MyMoney',
    data () {
        return {
            user: {},
            money: {},
            monies: {},
            bank:{},
            to_pay_out: 0,
            amount_paid: '',
            editBankFlag: false,
            bank_set: false,
            payment_request: false
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    methods: {
        //settings
        setPanel() {
            this.panelFlag = true
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getMonies() {
           let user_id = localStorage.getItem("cityneeds_token_key");
           service.getMonies(this, user_id).then(data => {
               if(data.body.status == 200) {
                    this.monies = data.body.data;
                    let result = data.body.data;
                    let total = 0;
                    result.forEach(function(element) {
                        this.to_pay_out += element.contract_money_pay_out;
                    }, this);
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //get all saved listing
        getMoney(id) {
           service.getMoney(this, id).then(data => {
               if(data.body.status == 200) {
                    this.money = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getBanking() {
            let user_id = localStorage.getItem("cityneeds_token_key");
            service.getBanking(this, user_id).then(data => {
                if(data.body.status == 200) {
                     this.bank = data.body.data;
                     this.bank_set = true;
               }
             }).catch((err) => {
                 if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
         },

        setBanking(){
            if(this.bank.bank_name == null || this.bank.account_name == null || this.bank.account_number == null){
                toastr.error('Kindly enter all fields', 'Warning!');
            }else{
                this.bank.bank_user = this.user.user_id;
                service.setBanking(this, this.bank).then((response) => {
                    if(response.status == 201) {
                        this.bank_set = true;
                    }
                }).catch((err) => {
                    if(err.status == 500) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                    }
                })
            }
        },
        editBank(){
            this.editBankFlag = true;
            this.bank_set = false;
        },

        updateBankSetting(){
            if(this.bank.bank_name == null || this.bank.account_name == null || this.bank.account_number == null){
                toastr.error('Kindly enter all fields', 'Warning!');
            }else{
                service.updateBankSetting(this, this.bank.bank_id, this.bank).then((response) => {
                    if(response.status == 200) {
                        this.bank_set = true;
                    }
                }).catch((err) => {
                    if(err.status == 500) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                    }
                })
            }
        },

        setPayment(money){
            this.money = money;
            this.payment_request = true;
        },

        // process payments
        processPayment() {
            service.updateMoniesPaid(this, this.money.contract_money_id, this.money).then(data => {
                if(data.body.status == 200) {
                    toastr.success("Payment Request Sent", "Ok!");
                    this.$router.go('/mymoney');
                }else {
                    toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
        },
        
    },
    created: function(){
        this.preset();
        this.getMonies();
        this.getBanking();
    }
}


// WEBPACK FOOTER //
// ./src/components/MyMoney/script.js